var _style, _g, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIqonPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.15;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{opacity:0.4;}\n\t.st5{clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st6{clip-path:url(#SVGID_4_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "play",
    d: "M20.9,10.1l-12-6.9C7.5,2.4,5.7,3.4,5.7,5.1v13.8c0,1.7,1.8,2.7,3.3,1.9l12-6.9C22.4,13.1,22.4,10.9,20.9,10.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "border"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "keylines"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqonPlay);
export default __webpack_public_path__ + "static/media/iqon_play.b3f78054.svg";
export { ForwardRef as ReactComponent };